import type {
  IntegrationItem,
  TechnologyItem,
} from "../../../../pages/hid-admin/dashboard/partner-settings/technology-management/types";
import type { IntegrationApiItem, TechnologyApiItem } from "./Types";

const mapStatusApiToUi = (status: number): "Active" | "Inactive" =>
  status === 1 ? "Active" : "Inactive";

const mapIntegrationApiToUi = (
  integration: IntegrationApiItem
): IntegrationItem => ({
  id: String(integration.id),
  name: integration.integration_name,
  description: integration.description || "",
  status: mapStatusApiToUi(integration.status),
});

export const mapTechnologyApiToUi = (
  technology: TechnologyApiItem
): TechnologyItem => ({
  id: String(technology.id),
  name: technology.technology_name,
  description: technology.description || "",
  status: mapStatusApiToUi(technology.status),
  integrations: (technology.integrations || []).map(mapIntegrationApiToUi),
});

export const mapTechnologiesApiToUi = (
  technologies: TechnologyApiItem[]
): TechnologyItem[] => technologies.map(mapTechnologyApiToUi);
